import {Fragment, useMemo} from "react";
import {Box, Stack, SxProps, Theme} from "@mui/material";

import {BmHelperText} from "~/components/helperText";
import {BmCardTitle} from "~/components/titles";

import {BmCardViewSectionDividerNew} from "./private/CardViewSectionDividerNew";
import {BmCardViewSectionPaperNew} from "../CardViewSectionPaperNew/CardViewSectionPaperNew";

export interface BmCardViewSectionNewProps {
  className?: string;
  sx?: SxProps<Theme>;
  bodySx?: SxProps<Theme>;
  wrapByPaper?: boolean;
  showDivider?: boolean;
  title: React.ReactNode;
  titleRight?: React.ReactNode;
  subtitle?: string;
  children: React.ReactNode;
}

export const BmCardViewSectionNew: React.FC<BmCardViewSectionNewProps> = ({
  className,
  sx,
  bodySx,
  wrapByPaper = true,
  showDivider = true,
  title,
  titleRight,
  subtitle,
  children,
}) => {
  const Wrapper = useMemo(() => (wrapByPaper ? BmCardViewSectionPaperNew : Fragment), [wrapByPaper]);
  return (
    <Box component="section" className={className} sx={sx}>
      <Wrapper {...(wrapByPaper ? {sx: {height: "100%"}} : {})}>
        <Stack direction="column" spacing={4} useFlexGap sx={{...bodySx}}>
          <Stack component="header" direction="column" spacing={1} useFlexGap>
            <Stack
              direction="row"
              spacing={1}
              sx={{
                alignItems: "center",
                alignSelf: "stretch",
                justifyContent: "space-between",
                padding: subtitle ? "0" : "3px 0",
              }}
              useFlexGap
            >
              <BmCardTitle>{title}</BmCardTitle>
              {titleRight}
            </Stack>

            {subtitle && <BmHelperText sx={{margin: 0}} dangerouslySetInnerHTML={{__html: subtitle}} />}

            {showDivider && <BmCardViewSectionDividerNew />}
          </Stack>

          {children}
        </Stack>
      </Wrapper>
    </Box>
  );
};
